import React from 'react';
import styles from './Progress.module.scss';

interface ProgressProps {
    /** Main statistic to highlight */
    mainNumber: number;
    /** Progress starting value */
    startValue?: number;
    /** Progress end value */
    endValue?: number;
    /** Progress color */
    color?: string;
    /** Extra className */
    className?: string;
    /** Arbitrary marker value to display as a point */
    markerValue?: number;
}

export const Progress: React.FC<ProgressProps> = ({
    mainNumber,
    startValue = 0,
    endValue = 100,
    color = "#434343",
    className,
    markerValue,
}) => {
    const calculatePercentage = (value: number, start: number, end: number) => {
        const percentage = ((value - start) / (end - start)) * 100;
        return percentage;
    };
    const relativePercentage = calculatePercentage(mainNumber, startValue, endValue);
    
    const markerPosition = markerValue !== undefined 
        ? calculatePercentage(markerValue, startValue, endValue) 
        : null;

    const lightenColor = (color: string, percent: number) => {
        const num = Number.parseInt(color.replace('#', ''), 16);
        const amt = Math.round(2.55 * percent);
        const R = (num >> 16) + amt;
        const G = (num >> 8 & 0x00FF) + amt;
        const B = (num & 0x0000FF) + amt;
        return `#${(0x1000000 + 
                  (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + 
                  (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + 
                  (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1)}`;
    };

    const lighterColor = lightenColor(color, 40);

    return (
        <div className={`${styles.progressBarContainer} ${className}`} role="progress">
            <div
                className={styles.currentProgressBar}
                style={{
                    width: `${relativePercentage}%`,
                    background: `linear-gradient(to right, ${lighterColor}, ${color})`,
                }}
            >
                <div className={styles.progressBar}>
                    <div className={styles.progressBarContent} />
                </div>
            </div>
            {markerPosition !== null && (
                <div
                    className={styles.marker}
                    style={{
                        left: `${markerPosition}%`,
                        backgroundColor: `${color}`
                    }}
                    title={`Marker: ${markerValue}`}
                />
            )}
        </div>
    );
};